// extracted by mini-css-extract-plugin
module.exports = {"container":"OnBoardingDetails_container__2ZMWO","loading":"OnBoardingDetails_loading__3ubqB"};